import React from 'react';
import usePersistedState from '../usePersistedState';
import SpecSheets from './SpecSheets';
import FormatBuilder from './FormatBuilder';

export default function SpecHub() {
  const [tab, setTab] = usePersistedState('spechub.tab', 'sheets');
  const user = (() => { try { return JSON.parse(localStorage.getItem('npd_user')); } catch { return null; } })();
  const role = user?.role || '';
  const canManageFormats = ['admin', 'standard', 'qc_manager'].includes(role) || user?.username === 'admin';

  return (
    <div>
      <div className="tabs" style={{ marginBottom: 16 }}>
        <button className={`tab ${tab === 'sheets' ? 'active' : ''}`} onClick={() => setTab('sheets')}>Spec Sheets</button>
        {canManageFormats && (
          <button className={`tab ${tab === 'formats' ? 'active' : ''}`} onClick={() => setTab('formats')}>Spec Formats</button>
        )}
      </div>
      {tab === 'sheets' ? <SpecSheets /> : <FormatBuilder />}
    </div>
  );
}
